import { HFlow, Text } from 'bold-ui'
import { SelectField, SelectFieldProps } from 'components/form'
import { UnidadesSaudeSelectFieldQuery } from 'graphql/types.generated'

export type UnidadeSaudeSelectModel = UnidadesSaudeSelectFieldQuery['unidadesSaude']['content'][0]

type CompartilhamentoCuidadoUnidadeSaudeSelectFieldProps = DistributiveOmit<
  SelectFieldProps<UnidadeSaudeSelectModel>,
  'itemToString'
> & {
  items: UnidadeSaudeSelectModel[]
}

export function CompartilhamentoCuidadoUnidadeSaudeSelectField(
  props: CompartilhamentoCuidadoUnidadeSaudeSelectFieldProps
) {
  return <SelectField<UnidadeSaudeSelectModel> itemToString={itemToString} renderItem={renderItem} {...props} />
}

const itemToString = (option: UnidadeSaudeSelectModel) => option && option.nome

const renderItem = (item: UnidadeSaudeSelectModel) => (
  <>
    <Text fontWeight='bold'>{item.nome}</Text>
    <HFlow hSpacing={0.5}>
      <Text fontWeight='bold'>CNES:</Text>
      {item.cnes}
    </HFlow>
  </>
)
